import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const getBrandings = createAsyncThunk('BrandingSlice/getBrandings', async () => {
  const response = await axios.get(`Brandings/getbrandings`);
  return response.data;
});

export const getSingleBranding = createAsyncThunk('BrandingSlice/getSingleBranding', async (id) => {
  const response = await axios.get(`Brandings/getsinglebrandings?id=${id}`);
  return { status: response.status, data: response.data };
});

export const createBranding = createAsyncThunk('BrandingSlice/createBranding', async (value) => {
  try {
    const response = await axios.post(`Brandings/createbranding`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const updateBranding = createAsyncThunk('BrandingSlice/updateBranding', async (value) => {
  try {
    const response = await axios.put(`Brandings/updatebranding`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const deleteBranding = createAsyncThunk('BrandingSlice/deleteBranding', async (id) => {
  try {
    const response = await axios.delete(`Brandings/deletebrandings?id=${id}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const allowedHosts = createAsyncThunk('BrandingSlice/allowedHosts', async (data) => {
  try {
    const response = await axios.put(`Brandings/allowedhosts`, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});

export const getAllowedHosts = createAsyncThunk('BrandingSlice/getAllowedHosts', async (value) => {
  const response = await axios.get(`Brandings/getallowedhosts`);
  return response.data;
});

const initialState = {
  data: [],
  loading: false,
  allowedHostStatus: false,
};

const brandingSlice = createSlice({
  name: 'brandingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBrandings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBrandings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBrandings.rejected, (state) => {
        state.loading = false;
        state.data = [];
      })
      .addCase(getAllowedHosts.fulfilled, (state, action) => {
        state.allowedHostStatus = action.payload;
      })
      .addCase(getAllowedHosts.rejected, (state) => {
        state.allowedHostStatus = false;
      });
  },
});
export default brandingSlice.reducer;
